


































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';

//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'
//@ts-ignore

import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import DependenciasHeader from '@/components/headersSelect/dependencias'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore

import Notiflix from "notiflix";
import { Row } from 'jspdf-autotable';
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    TablePPoa,
    DependenciasHeader
    

  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
        columnasd:[
           
            
            
            
             {
                tag:'visible',
                data:'visible',
                active:false
            },
            {
                tag:'nombre',
                data:'nombre',
                active:true
            },
             {
                tag:'clave',
                data:'clave',
                active:true
            },
           
             {
                tag:'nombre_titular',
                data:'nombre_titular',
                active:true
            }, {
                tag:'correo',
                data:'correo',
                active:true
            },
             {
                tag:'abreviacion',
                data:'abreviacion',
                active:true
            },
             {
                tag:'color',
                data:'color',
                active:true
            },
             {
                tag:'select_dep',
                data:'select',
                active:false
            },
            {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
           
        ],
     /*   color_list:[
    {
        id:red,
        nombre:red
    },
    {
        id:green,
        nombre:green
    },
     {
        id:yellow,
        nombre:yellow
    },
    {
        id:pink,
        nombre:pink
    },
    {
        id:purple,
        nombre:purple
    },

],*/
    departamentos:false,



        id:null as any,

      nombre:'' as any,
        clave:'' as any,
      
      nombre_titular:'' as any,
      correo:'' as any,
      abreviacion:'' as any,
    color:0 as any,
     visible:0 as any,
         
              dependencias:[] as any,
              
      
    }
  },
     mixins: [dependencias],
     validations: {
    
           nombre: {
      required,
    },
     
       clave: {
      required,
    },
     
     nombre_titular: {
      required,
    },
   
     abreviacion: {
      required,
    },
   color: {
      required,
    },
  visible: {
      required,
    },
     

   
  },
  methods:{
       onChangeVisible(event){
event: this.visible
      },
        clearstate(){
this.$store.commit('SETSECRETARIA',null);
 this.$router.push('/mun/general/secretarias')
        },

      async eliminar(row){
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_SECRETARIAS(row).then(response => {

                    if (response != null) {

 this.dependencias=this.dependencias.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la página");

                    }
 this.$root.$emit('loading', false);
                });
      },
       select(row){


           //this.secretaria_sel=row;
//this.departamentos=true;
 this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/secretarias/departamentos')
//this.getDataDepartamentos();

      
     },
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.nombre=null;

            this.clave=null;
              this.nombre_titular=null;
               this.correo=null;
                this.abreviacion=null;
    this.color=0;
            this.visible=0;
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_dependencias').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.nombre=row.nombre;
 this.visible=row.visible;
            this.clave=row.clave;
              this.nombre_titular=row.nombre_titular;
               this.correo=row.correo;
                this.abreviacion=row.abreviacion;
                this.color=row.color;
 $('#ac_modal_dependencias').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_SECRETARIAS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.dependencias.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar paquete, refresque la página");

                    }
                     $("#ac_modal_dependencias").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_SECRETARIAS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Dependencia modificada correctamente.");
  this.dependencias=this.dependencias.filter(item => item.id !== dat.id);
 this.dependencias.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear dependencias, refresque la página");

                    }
 this.$root.$emit('loading', false);
 $("#ac_modal_dependencias").modal("hide");
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
           nombre:this.nombre,
visible:this.visible,
            clave:this.clave,
              nombre_titular:this.nombre_titular,
               correo:this.correo,
                abreviacion:this.abreviacion,
                color:this.color,
                 idmunicipio:this.$store.state.user.usuario.id_municipio
    
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_SECRETARIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.dependencias=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la página");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},


async getDataDepartamentos() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:this.secretaria_sel.id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la página");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
}
  },
  mounted(){
       Notiflix.Confirm.Init({ titleColor:"#d02424",okButtonBackground:"#d71c1c", }); 
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

